class FeatureUsageModule {
  static name() {
    return "FeatureUsageModule";
  }
  static getRoutes() {
    return [
      {
        path: "/feature-usage",
        component: () => import("./views/featureUsage"),
        name: "featureUsage",
        meta: { requiresAuth: true, layout: "Admin" }
      },
      {
        path: "/feature-usage/:feature",
        component: () => import("./views/IndividualFeatureUsage.vue"),
        name: "individualFeatureUsage",
        meta: { requiresAuth: true, layout: "Admin" }
      }
    ];
  }
}

export default FeatureUsageModule;
